/* The Lady CRO: keep the mobile price in sync with Shopify's native variant price. */
(function () {
  function init(root) {
    (root || document).querySelectorAll('product-info .tl-cro-mobile-intro[data-tl-cro-mobile-intro]').forEach(function(intro) {
      if (intro.dataset.tlCroInitialized === 'true') return;
      var productInfo = intro.closest('product-info');
      if (!productInfo) return;
      var source = productInfo.querySelector('[id^="price-"]');
      var target = intro.querySelector('[data-tl-cro-price]');
      if (!source || !target) return;
      intro.dataset.tlCroInitialized = 'true';
      function syncPrice() {
        var price = source.querySelector('.price');
        if (price) target.innerHTML = price.outerHTML;
      }
      syncPrice();
      new MutationObserver(syncPrice).observe(source, { childList: true, subtree: true, characterData: true, attributes: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function(event) { init(event.target); });
})();
